import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ScreenshotMonitor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3H2v16h6v2h8v-2h6V3zm-2 14H4V5h16v12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
  }));
});
ScreenshotMonitor.displayName = 'ScreenshotMonitor';
export var ScreenshotMonitorDimensions = {
  height: 24,
  width: 24
};